//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IDeliveryProcessDefinitionClient {
    /**
     * Methode voor het ophalen van alle beschikbare leveringsprocesdefinities.
     */
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryProcessDefinition[]>;
    /**
     * Methode voor het ophalen van de dataoperaties gekoppeld aan een specifieke leveringsprocesdefinitie.
     * @param id Identificerend veld van de gekozen leveringsprocesdefinitie.
     * @return Lijst van dataoperaties aan leverzijde.
     */
    getTransformations(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryTransformation[]>;
    /**
     * Methode voor het ophalen van de operationele entiteiten gekoppeld aan een specifieke leveringsprocesdefinitie.
     * @param id Identificerend veld van de gekozen leveringsprocesdefinitie.
     * @return Lijst van operationele entiteiten.
     */
    getOperationEntities(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<OperationEntity[]>;
}

export class DeliveryProcessDefinitionClient implements IDeliveryProcessDefinitionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Methode voor het ophalen van alle beschikbare leveringsprocesdefinities.
     */
    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryProcessDefinition[]> {
        let url_ = this.baseUrl + "/api/v1/deliveryprocessdefinition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DeliveryProcessDefinition[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryProcessDefinition[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryProcessDefinition[]>(null as any);
    }

    /**
     * Methode voor het ophalen van de dataoperaties gekoppeld aan een specifieke leveringsprocesdefinitie.
     * @param id Identificerend veld van de gekozen leveringsprocesdefinitie.
     * @return Lijst van dataoperaties aan leverzijde.
     */
    getTransformations(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryTransformation[]> {
        let url_ = this.baseUrl + "/api/v1/deliveryprocessdefinition/{id}/transformations";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransformations(_response);
        });
    }

    protected processGetTransformations(response: AxiosResponse): Promise<DeliveryTransformation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryTransformation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryTransformation[]>(null as any);
    }

    /**
     * Methode voor het ophalen van de operationele entiteiten gekoppeld aan een specifieke leveringsprocesdefinitie.
     * @param id Identificerend veld van de gekozen leveringsprocesdefinitie.
     * @return Lijst van operationele entiteiten.
     */
    getOperationEntities(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<OperationEntity[]> {
        let url_ = this.baseUrl + "/api/v1/deliveryprocessdefinition/{id}/operationentities";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOperationEntities(_response);
        });
    }

    protected processGetOperationEntities(response: AxiosResponse): Promise<OperationEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<OperationEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationEntity[]>(null as any);
    }
}

export interface IDeliveryRunClient {
    /**
     * Get all delivery runs
     * @param definition (optional) Delivery definition
     * @param supplier (optional) Supplier
     * @param fileName (optional) Delivery filename
     * @param username (optional) Username
     * @param startExecutionFrom (optional) Delivery run execution end time
     * @param startExecutionTo (optional) Delivery run execution end time
     * @param status (optional) Delivery run status
     * @param isDryRun (optional) Is it a dry run?
     * @param by (optional) 
     * @param descending (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    getAll(definition?: number | null | undefined, supplier?: number | null | undefined, fileName?: string | null | undefined, username?: string | null | undefined, startExecutionFrom?: Date | null | undefined, startExecutionTo?: Date | null | undefined, status?: number | null | undefined, isDryRun?: boolean | null | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SearchResultOfDeliveryFilterAndDeliverySearchResult>;
    /**
     * Create delivery
     */
    createDelivery(createDelivery: CreateDelivery, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryRun>;
    /**
     * Get delivery run
     */
    get(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryRun>;
    /**
     * Get delivery status history
     */
    getDeliveryStatusHistory(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryStatusHistory[]>;
    /**
     * Get delivery statusses
     */
    getDeliveryStatusses(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryStatus[]>;
    /**
     * Get file
     */
    getFile(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Create delivery dry run
     * @param includeProductProcessDefinitions (optional) 
     * @param importData (optional) 
     * @param includeTriggeredDeliveryDefinitions (optional) 
     */
    createDryRun(deliveryDefinitionId: number, includeProductProcessDefinitions?: boolean | undefined, importData?: boolean | undefined, includeTriggeredDeliveryDefinitions?: boolean | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Update product information
     */
    updateProduct(id: number, product: Product, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    upload(id: number, file?: FileParameter | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Cancel delivery run
     */
    cancel(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class DeliveryRunClient implements IDeliveryRunClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get all delivery runs
     * @param definition (optional) Delivery definition
     * @param supplier (optional) Supplier
     * @param fileName (optional) Delivery filename
     * @param username (optional) Username
     * @param startExecutionFrom (optional) Delivery run execution end time
     * @param startExecutionTo (optional) Delivery run execution end time
     * @param status (optional) Delivery run status
     * @param isDryRun (optional) Is it a dry run?
     * @param by (optional) 
     * @param descending (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    getAll(definition?: number | null | undefined, supplier?: number | null | undefined, fileName?: string | null | undefined, username?: string | null | undefined, startExecutionFrom?: Date | null | undefined, startExecutionTo?: Date | null | undefined, status?: number | null | undefined, isDryRun?: boolean | null | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SearchResultOfDeliveryFilterAndDeliverySearchResult> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun?";
        if (definition !== undefined && definition !== null)
            url_ += "Definition=" + encodeURIComponent("" + definition) + "&";
        if (supplier !== undefined && supplier !== null)
            url_ += "Supplier=" + encodeURIComponent("" + supplier) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (username !== undefined && username !== null)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        if (startExecutionFrom !== undefined && startExecutionFrom !== null)
            url_ += "StartExecutionFrom=" + encodeURIComponent(startExecutionFrom ? "" + startExecutionFrom.toISOString() : "") + "&";
        if (startExecutionTo !== undefined && startExecutionTo !== null)
            url_ += "StartExecutionTo=" + encodeURIComponent(startExecutionTo ? "" + startExecutionTo.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isDryRun !== undefined && isDryRun !== null)
            url_ += "IsDryRun=" + encodeURIComponent("" + isDryRun) + "&";
        if (by !== undefined && by !== null)
            url_ += "By=" + encodeURIComponent("" + by) + "&";
        if (descending !== undefined && descending !== null)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SearchResultOfDeliveryFilterAndDeliverySearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SearchResultOfDeliveryFilterAndDeliverySearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultOfDeliveryFilterAndDeliverySearchResult>(null as any);
    }

    /**
     * Create delivery
     */
    createDelivery(createDelivery: CreateDelivery , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryRun> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDelivery);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDelivery(_response);
        });
    }

    protected processCreateDelivery(response: AxiosResponse): Promise<DeliveryRun> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<DeliveryRun>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryRun>(null as any);
    }

    /**
     * Get delivery run
     */
    get(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryRun> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DeliveryRun> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryRun>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryRun>(null as any);
    }

    /**
     * Get delivery status history
     */
    getDeliveryStatusHistory(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryStatusHistory[]> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun/{id}/deliverystatushistory";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryStatusHistory(_response);
        });
    }

    protected processGetDeliveryStatusHistory(response: AxiosResponse): Promise<DeliveryStatusHistory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryStatusHistory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryStatusHistory[]>(null as any);
    }

    /**
     * Get delivery statusses
     */
    getDeliveryStatusses( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryStatus[]> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun/statusses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryStatusses(_response);
        });
    }

    protected processGetDeliveryStatusses(response: AxiosResponse): Promise<DeliveryStatus[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryStatus[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryStatus[]>(null as any);
    }

    /**
     * Get file
     */
    getFile(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun/{id}/file";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Create delivery dry run
     * @param includeProductProcessDefinitions (optional) 
     * @param importData (optional) 
     * @param includeTriggeredDeliveryDefinitions (optional) 
     */
    createDryRun(deliveryDefinitionId: number, includeProductProcessDefinitions?: boolean | undefined, importData?: boolean | undefined, includeTriggeredDeliveryDefinitions?: boolean | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun/{deliveryDefinitionId}/dryrun?";
        if (deliveryDefinitionId === undefined || deliveryDefinitionId === null)
            throw new globalThis.Error("The parameter 'deliveryDefinitionId' must be defined.");
        url_ = url_.replace("{deliveryDefinitionId}", encodeURIComponent("" + deliveryDefinitionId));
        if (includeProductProcessDefinitions === null)
            throw new globalThis.Error("The parameter 'includeProductProcessDefinitions' cannot be null.");
        else if (includeProductProcessDefinitions !== undefined)
            url_ += "includeProductProcessDefinitions=" + encodeURIComponent("" + includeProductProcessDefinitions) + "&";
        if (importData === null)
            throw new globalThis.Error("The parameter 'importData' cannot be null.");
        else if (importData !== undefined)
            url_ += "importData=" + encodeURIComponent("" + importData) + "&";
        if (includeTriggeredDeliveryDefinitions === null)
            throw new globalThis.Error("The parameter 'includeTriggeredDeliveryDefinitions' cannot be null.");
        else if (includeTriggeredDeliveryDefinitions !== undefined)
            url_ += "includeTriggeredDeliveryDefinitions=" + encodeURIComponent("" + includeTriggeredDeliveryDefinitions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDryRun(_response);
        });
    }

    protected processCreateDryRun(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update product information
     */
    updateProduct(id: number, product: Product , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun/{id}/product";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProduct(_response);
        });
    }

    protected processUpdateProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upload(id: number, file?: FileParameter | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun/{id}/datatset";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Cancel delivery run
     */
    cancel(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/deliveryrun/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDeliverySpecificationClient {
    /**
     * Get all delivery specifications
     */
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliverySpecification[]>;
    /**
     * Get delivery entities
     */
    getDeliveryEntities(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryEntity[]>;
}

export class DeliverySpecificationClient implements IDeliverySpecificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get all delivery specifications
     */
    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliverySpecification[]> {
        let url_ = this.baseUrl + "/api/v1/deliveryspecification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DeliverySpecification[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliverySpecification[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliverySpecification[]>(null as any);
    }

    /**
     * Get delivery entities
     */
    getDeliveryEntities(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryEntity[]> {
        let url_ = this.baseUrl + "/api/v1/deliveryspecification/{id}/deliveryentities";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryEntities(_response);
        });
    }

    protected processGetDeliveryEntities(response: AxiosResponse): Promise<DeliveryEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryEntity[]>(null as any);
    }
}

export interface IEntityModelClient {
    /**
     * Get all entity models
     */
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<EntityModel[]>;
    get(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<EntityModel>;
    /**
     * Get entity attributes
     */
    getEntityAttributes(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<EntityAttribute[]>;
}

export class EntityModelClient implements IEntityModelClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get all entity models
     */
    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<EntityModel[]> {
        let url_ = this.baseUrl + "/api/v1/entitymodel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<EntityModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<EntityModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModel[]>(null as any);
    }

    get(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<EntityModel> {
        let url_ = this.baseUrl + "/api/v1/entitymodel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<EntityModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<EntityModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModel>(null as any);
    }

    /**
     * Get entity attributes
     */
    getEntityAttributes(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<EntityAttribute[]> {
        let url_ = this.baseUrl + "/api/v1/entitymodel/{id}/entityattributes";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntityAttributes(_response);
        });
    }

    protected processGetEntityAttributes(response: AxiosResponse): Promise<EntityAttribute[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<EntityAttribute[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityAttribute[]>(null as any);
    }
}

export interface IProductProcessDefinitionClient {
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductProcessDefinition[]>;
    /**
     * Get transformations
     */
    getTransformations(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductTransformation[]>;
    /**
     * Get source entities
     */
    getSourceEntities(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SourceEntity[]>;
}

export class ProductProcessDefinitionClient implements IProductProcessDefinitionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductProcessDefinition[]> {
        let url_ = this.baseUrl + "/api/v1/productprocessdefinition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProductProcessDefinition[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductProcessDefinition[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductProcessDefinition[]>(null as any);
    }

    /**
     * Get transformations
     */
    getTransformations(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductTransformation[]> {
        let url_ = this.baseUrl + "/api/v1/productprocessdefinition/{id}/transformations";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransformations(_response);
        });
    }

    protected processGetTransformations(response: AxiosResponse): Promise<ProductTransformation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductTransformation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductTransformation[]>(null as any);
    }

    /**
     * Get source entities
     */
    getSourceEntities(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SourceEntity[]> {
        let url_ = this.baseUrl + "/api/v1/productprocessdefinition/{id}/sourceentities";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourceEntities(_response);
        });
    }

    protected processGetSourceEntities(response: AxiosResponse): Promise<SourceEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SourceEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceEntity[]>(null as any);
    }
}

export interface IProductRunClient {
    /**
     * Get all products
     * @param definition (optional) Product definition
     * @param versionDescription (optional) Product metadata version description
     * @param startExecutionFrom (optional) Product run execution start time
     * @param startExecutionTo (optional) Product run execution end time
     * @param status (optional) Product run status
     * @param isDryRun (optional) Is it a dry run?
     * @param productGroupLabel (optional) The label of a product group: only the runs of the definitions in that group are returned
     * @param by (optional) 
     * @param descending (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    getAll(definition?: number | null | undefined, versionDescription?: string | null | undefined, startExecutionFrom?: Date | null | undefined, startExecutionTo?: Date | null | undefined, status?: number | null | undefined, isDryRun?: boolean | null | undefined, productGroupLabel?: string | null | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SearchResultOfProductFilterAndProductSearchResult>;
    /**
     * Create product
     */
    createProduct(createProduct: CreateProduct, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductRun>;
    /**
     * Get product
     */
    get(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductRun>;
    /**
     * Get product status history
     */
    getProductStatusHistory(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductStatusHistory[]>;
    /**
     * Get product statusses
     */
    getProductStatusses(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryStatus[]>;
    /**
     * Get product groups, sorted by label
     */
    getProductGroups(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductGroup[]>;
    /**
     * Update metadata information
     */
    updateMetadata(id: number, metadata: Metadata, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Create product dry run
     * @param importData (optional) 
     * @param importMetadata (optional) 
     * @param includeTriggeredProductDefinitions (optional) 
     */
    createDryRun(productDefinitionId: number, importData?: boolean | undefined, importMetadata?: boolean | undefined, includeTriggeredProductDefinitions?: boolean | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Cancel product run
     */
    cancel(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class ProductRunClient implements IProductRunClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get all products
     * @param definition (optional) Product definition
     * @param versionDescription (optional) Product metadata version description
     * @param startExecutionFrom (optional) Product run execution start time
     * @param startExecutionTo (optional) Product run execution end time
     * @param status (optional) Product run status
     * @param isDryRun (optional) Is it a dry run?
     * @param productGroupLabel (optional) The label of a product group: only the runs of the definitions in that group are returned
     * @param by (optional) 
     * @param descending (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    getAll(definition?: number | null | undefined, versionDescription?: string | null | undefined, startExecutionFrom?: Date | null | undefined, startExecutionTo?: Date | null | undefined, status?: number | null | undefined, isDryRun?: boolean | null | undefined, productGroupLabel?: string | null | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SearchResultOfProductFilterAndProductSearchResult> {
        let url_ = this.baseUrl + "/api/v1/productrun?";
        if (definition !== undefined && definition !== null)
            url_ += "Definition=" + encodeURIComponent("" + definition) + "&";
        if (versionDescription !== undefined && versionDescription !== null)
            url_ += "VersionDescription=" + encodeURIComponent("" + versionDescription) + "&";
        if (startExecutionFrom !== undefined && startExecutionFrom !== null)
            url_ += "StartExecutionFrom=" + encodeURIComponent(startExecutionFrom ? "" + startExecutionFrom.toISOString() : "") + "&";
        if (startExecutionTo !== undefined && startExecutionTo !== null)
            url_ += "StartExecutionTo=" + encodeURIComponent(startExecutionTo ? "" + startExecutionTo.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isDryRun !== undefined && isDryRun !== null)
            url_ += "IsDryRun=" + encodeURIComponent("" + isDryRun) + "&";
        if (productGroupLabel !== undefined && productGroupLabel !== null)
            url_ += "ProductGroupLabel=" + encodeURIComponent("" + productGroupLabel) + "&";
        if (by !== undefined && by !== null)
            url_ += "By=" + encodeURIComponent("" + by) + "&";
        if (descending !== undefined && descending !== null)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SearchResultOfProductFilterAndProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SearchResultOfProductFilterAndProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultOfProductFilterAndProductSearchResult>(null as any);
    }

    /**
     * Create product
     */
    createProduct(createProduct: CreateProduct , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductRun> {
        let url_ = this.baseUrl + "/api/v1/productrun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createProduct);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProduct(_response);
        });
    }

    protected processCreateProduct(response: AxiosResponse): Promise<ProductRun> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<ProductRun>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductRun>(null as any);
    }

    /**
     * Get product
     */
    get(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductRun> {
        let url_ = this.baseUrl + "/api/v1/productrun/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProductRun> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductRun>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductRun>(null as any);
    }

    /**
     * Get product status history
     */
    getProductStatusHistory(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductStatusHistory[]> {
        let url_ = this.baseUrl + "/api/v1/productrun/{id}/productstatushistory";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductStatusHistory(_response);
        });
    }

    protected processGetProductStatusHistory(response: AxiosResponse): Promise<ProductStatusHistory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductStatusHistory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductStatusHistory[]>(null as any);
    }

    /**
     * Get product statusses
     */
    getProductStatusses( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryStatus[]> {
        let url_ = this.baseUrl + "/api/v1/productrun/statusses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductStatusses(_response);
        });
    }

    protected processGetProductStatusses(response: AxiosResponse): Promise<DeliveryStatus[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryStatus[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryStatus[]>(null as any);
    }

    /**
     * Get product groups, sorted by label
     */
    getProductGroups( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductGroup[]> {
        let url_ = this.baseUrl + "/api/v1/productrun/productgroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductGroups(_response);
        });
    }

    protected processGetProductGroups(response: AxiosResponse): Promise<ProductGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductGroup[]>(null as any);
    }

    /**
     * Update metadata information
     */
    updateMetadata(id: number, metadata: Metadata , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/productrun/{id}/metadata";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadata);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMetadata(_response);
        });
    }

    protected processUpdateMetadata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create product dry run
     * @param importData (optional) 
     * @param importMetadata (optional) 
     * @param includeTriggeredProductDefinitions (optional) 
     */
    createDryRun(productDefinitionId: number, importData?: boolean | undefined, importMetadata?: boolean | undefined, includeTriggeredProductDefinitions?: boolean | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/productrun/{productDefinitionId}/dryrun?";
        if (productDefinitionId === undefined || productDefinitionId === null)
            throw new globalThis.Error("The parameter 'productDefinitionId' must be defined.");
        url_ = url_.replace("{productDefinitionId}", encodeURIComponent("" + productDefinitionId));
        if (importData === null)
            throw new globalThis.Error("The parameter 'importData' cannot be null.");
        else if (importData !== undefined)
            url_ += "importData=" + encodeURIComponent("" + importData) + "&";
        if (importMetadata === null)
            throw new globalThis.Error("The parameter 'importMetadata' cannot be null.");
        else if (importMetadata !== undefined)
            url_ += "importMetadata=" + encodeURIComponent("" + importMetadata) + "&";
        if (includeTriggeredProductDefinitions === null)
            throw new globalThis.Error("The parameter 'includeTriggeredProductDefinitions' cannot be null.");
        else if (includeTriggeredProductDefinitions !== undefined)
            url_ += "includeTriggeredProductDefinitions=" + encodeURIComponent("" + includeTriggeredProductDefinitions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDryRun(_response);
        });
    }

    protected processCreateDryRun(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Cancel product run
     */
    cancel(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/productrun/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProductSpecificationClient {
    /**
     * Get all product specifications
     */
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductSpecification[]>;
    /**
     * Get all product specifications by delivery definition ID
     * @param id Delivery Definition ID
     */
    getByDeliveryDefinitionId(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductSpecification[]>;
    /**
     * Get product entities
     */
    getProductEntities(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductEntity[]>;
    /**
     * Get formats
     */
    getFormats(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FormatType[]>;
}

export class ProductSpecificationClient implements IProductSpecificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get all product specifications
     */
    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductSpecification[]> {
        let url_ = this.baseUrl + "/api/v1/productspecification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProductSpecification[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductSpecification[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductSpecification[]>(null as any);
    }

    /**
     * Get all product specifications by delivery definition ID
     * @param id Delivery Definition ID
     */
    getByDeliveryDefinitionId(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductSpecification[]> {
        let url_ = this.baseUrl + "/api/v1/productspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDeliveryDefinitionId(_response);
        });
    }

    protected processGetByDeliveryDefinitionId(response: AxiosResponse): Promise<ProductSpecification[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductSpecification[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductSpecification[]>(null as any);
    }

    /**
     * Get product entities
     */
    getProductEntities(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductEntity[]> {
        let url_ = this.baseUrl + "/api/v1/productspecification/{id}/productentities";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductEntities(_response);
        });
    }

    protected processGetProductEntities(response: AxiosResponse): Promise<ProductEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntity[]>(null as any);
    }

    /**
     * Get formats
     */
    getFormats( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FormatType[]> {
        let url_ = this.baseUrl + "/api/v1/productspecification/formattypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormats(_response);
        });
    }

    protected processGetFormats(response: AxiosResponse): Promise<FormatType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<FormatType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormatType[]>(null as any);
    }
}

export interface ISchedulerClient {
    getSchedulerInfo(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<any>;
}

export class SchedulerClient implements ISchedulerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    getSchedulerInfo( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/scheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchedulerInfo(_response);
        });
    }

    protected processGetSchedulerInfo(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export interface ISetupClient {
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<number[]>;
    /**
     * If id is not 0: Converts the specification data to Datapublication DB with the specified product identifier from the original PBS DB.
    Special Id's:  Id=-1 for all PbsData, Id=-2 for all GrbData, Id=-6 for all POIdata.
    If no dbName is given, executes migrating GeoBeheer, else executes migrating a Product DB.
    Valid values of dbName: Bedrijven, Cadmap, Grb, Product, Rvv, Vha.
     * @param id The identifier.
     * @param dbName (optional) The database name.
     */
    post(id: number, dbName?: string | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    get(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<string>;
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class SetupClient implements ISetupClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/v1/setup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * If id is not 0: Converts the specification data to Datapublication DB with the specified product identifier from the original PBS DB.
    Special Id's:  Id=-1 for all PbsData, Id=-2 for all GrbData, Id=-6 for all POIdata.
    If no dbName is given, executes migrating GeoBeheer, else executes migrating a Product DB.
    Valid values of dbName: Bedrijven, Cadmap, Grb, Product, Rvv, Vha.
     * @param id The identifier.
     * @param dbName (optional) The database name.
     */
    post(id: number, dbName?: string | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/setup?";
        if (dbName !== undefined && dbName !== null)
            url_ += "dbName=" + encodeURIComponent("" + dbName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    get(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/setup/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/setup/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISupplierClient {
    /**
     * Get all suppliers
     */
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<Supplier[]>;
    /**
     * Search suppliers
     * @param filter (optional) 
     * @param by (optional) 
     * @param descending (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(filter?: SupplierFilter | null | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SearchResultOfSupplierFilterAndSupplierSearchResult>;
}

export class SupplierClient implements ISupplierClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get all suppliers
     */
    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<Supplier[]> {
        let url_ = this.baseUrl + "/api/v1/supplier";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Supplier[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<Supplier[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Supplier[]>(null as any);
    }

    /**
     * Search suppliers
     * @param filter (optional) 
     * @param by (optional) 
     * @param descending (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(filter?: SupplierFilter | null | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SearchResultOfSupplierFilterAndSupplierSearchResult> {
        let url_ = this.baseUrl + "/api/v1/supplier/search?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (by !== undefined && by !== null)
            url_ += "By=" + encodeURIComponent("" + by) + "&";
        if (descending !== undefined && descending !== null)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<SearchResultOfSupplierFilterAndSupplierSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SearchResultOfSupplierFilterAndSupplierSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultOfSupplierFilterAndSupplierSearchResult>(null as any);
    }
}

export interface IBuildInfoClient {
    index(x_version?: string | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
}

export class BuildInfoClient implements IBuildInfoClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    index(x_version?: string | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/buildinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "x-version": x_version !== undefined && x_version !== null ? "" + x_version : "",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IIdentityClient {
    current(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<UserIdentity>;
}

export class IdentityClient implements IIdentityClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.jsonParseReviver = jsonParseReviver;
    }

    current( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<UserIdentity> {
        let url_ = this.baseUrl + "/api/v1/identity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrent(_response);
        });
    }

    protected processCurrent(response: AxiosResponse): Promise<UserIdentity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<UserIdentity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserIdentity>(null as any);
    }
}

/** Overkoepelende beschrijving van een leveringsproces. */
export interface DeliveryProcessDefinition {
    id?: number;
    label?: string | null;
    statusId?: number;
    usesCodeLists?: boolean | null;
}

/** Dataoperatie aan leverzijde waarbij (een deel van) een geleverde entiteit naar (een deel van) een operationele entiteit omgezet wordt. */
export interface DeliveryTransformation {
    id?: number;
    transformationType?: TransformationType | null;
    fromEntity?: DeliveryEntity | null;
    toEntity?: OperationEntity | null;
    attributeMappings?: EntityAttributeMapping[] | null;
    parameter?: string | null;
}

/** Beschikbare types dataoperatie die (een deel van) een entiteit omzetten in (een deel van) een andere entiteit. */
export interface TransformationType {
    id?: number;
    name?: string | null;
}

/** Een verzameling van leveringsexemplaren met gemeenschappelijke kenmerken en attributen. */
export interface DeliveryEntity {
    id?: number;
    code?: string;
    label?: string;
    description?: string;
    format?: string;
    model?: EntityModel;
    crs?: Crs;
    dataSource?: DataConnection | null;
    schema?: string | null;
}

/** Beschrijving van een entiteit, met onder andere de naam, attribuutdefinities en het type geometrie. */
export interface EntityModel {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    contextType?: string | null;
    entityType?: string | null;
    hasHistory?: boolean | null;
    attributes?: EntityAttribute[] | null;
}

/** Beschrijving van een attribuut, een eigenschap van een entiteit, met onder andere de naam, datatype en precisie. */
export interface EntityAttribute {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    order?: number | null;
    dataType?: string | null;
    length?: number | null;
    decimalCount?: number | null;
    isIdentifying?: boolean | null;
    isMandatory?: boolean | null;
    isCalculated?: boolean | null;
}

/** Type geodetisch coördinatensysteem. */
export interface Crs {
    id?: number;
    name?: string | null;
}

export interface Entity {
    id?: number;
}

export interface DataConnection extends Entity {
    code?: string;
    label?: string;
    isReadOnly?: boolean;
    busyCount?: number;
    switch?: boolean;
    isSwitching?: boolean;
}

/** Een verzameling van getransformeerde leveringsexemplaren met gemeenschappelijke kenmerken en attributen. */
export interface OperationEntity {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    model?: EntityModel | null;
    crs?: Crs | null;
}

/** EntityAttribute mapping (from -> to entity attribute) */
export interface EntityAttributeMapping {
    /** From attribute */
    fromAttribute?: EntityAttribute | null;
    /** To attribute  */
    toAttribute?: EntityAttribute | null;
}

export interface SearchResultOfDeliveryFilterAndDeliverySearchResult {
    filter?: DeliveryFilter | null;
    results?: DeliverySearchResult[] | null;
    totalcount?: number | null;
    paging?: Paging | null;
    sorting?: Sorting | null;
}

export interface DeliveryFilter {
    /** Delivery definition */
    definition?: number | null;
    /** Supplier */
    supplier?: number | null;
    /** Delivery filename */
    fileName?: string | null;
    /** Username */
    username?: string | null;
    /** Delivery run execution end time */
    startExecutionFrom?: Date | null;
    /** Delivery run execution end time */
    startExecutionTo?: Date | null;
    /** Delivery run status */
    status?: number | null;
    /** Is it a dry run? */
    isDryRun?: boolean | null;
}

/** Delivery search result */
export interface DeliverySearchResult {
    /** Delivery run ID */
    id?: number;
    definition?: string | null;
    fileName?: string | null;
    supplier?: string | null;
    user?: string | null;
    startExecution?: Date | null;
    endExecution?: Date | null;
    status?: string | null;
    isDryRun?: boolean;
    /** Are there warnings or errors in the delivery run? */
    hasNotifications?: boolean;
}

export interface Paging {
    pageNumber?: number | null;
    pageSize?: number | null;
}

export interface Sorting {
    by?: string | null;
    descending?: boolean | null;
}

/** Uitvoering van een leveringsproces, inclusief statusinformatie en run step informatie. */
export interface DeliveryRun {
    id?: number;
    runId?: string | null;
    status?: string | null;
    step?: string | null;
    statusId?: number;
    failReason?: string | null;
    statusOn?: Date | null;
    createdBy?: string | null;
    createdOn?: Date | null;
    startExecution?: Date | null;
    endExecution?: Date | null;
    definitionId?: number | null;
    definition?: DeliveryProcessDefinition | null;
    fileName?: string | null;
    products?: Product[] | null;
    runSteps?: RunStep[] | null;
    qualityReport?: string | null;
    organisation?: string | null;
    isDryRun?: boolean;
    canAbort?: boolean;
}

export interface Product {
    isFirstTime?: boolean;
    versionDate?: Date | null;
    versionDescription?: string | null;
    temporalLimitationFrom?: Date | null;
    temporalLimitationTo?: Date | null;
    runTimestamp?: Date | null;
    productSpecificationId?: number | null;
    productSpecificationLabel?: string | null;
}

export interface RunStep {
    name?: string | null;
    entityName?: string | null;
    retryCount?: number | null;
    start?: Date | null;
    end?: Date | null;
    warnings?: string | null;
    error?: string | null;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface DeliveryStatusHistory {
    id?: number;
    status?: DeliveryStatusType | null;
    statusOn?: Date | null;
    statusBy?: string | null;
}

export interface DeliveryStatusType {
    id?: number;
    name?: string | null;
}

export interface DeliveryStatus {
    id?: number;
    name?: string | null;
}

export interface CreateDelivery {
    definitionId?: number;
    /** Product list */
    products?: Product[] | null;
}

/** Gedetailleerde beschrijving van een of meerdere datasets, inclusief leveringsmodaliteiten. Bevat de inhoud en vorm van de data, en hoe ze gevalideerd kan worden op correctheid. */
export interface DeliverySpecification {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    entityLinks?: DeliveryEntityLink[] | null;
}

/** Relatie die leveringsexemplaren van de ene met de andere entiteit verbindt. */
export interface DeliveryEntityLink {
    id?: number;
    fromEntity?: DeliveryEntity | null;
    toEntity?: DeliveryEntity | null;
    attributeMappings?: EntityAttributeMapping[] | null;
}

/** Overkoepelende beschrijving van een productproces. */
export interface ProductProcessDefinition {
    id?: number;
    label?: string | null;
    statusId?: number;
    deliveryDefinitionId?: number | null;
}

/** Dataoperatie aan productzijde waarbij (een deel van) een bron-entiteit naar (een deel van) een product-entiteit omgezet wordt. */
export interface ProductTransformation {
    id?: number;
    transformationType?: TransformationType | null;
    fromEntity?: SourceEntity | null;
    toEntity?: ProductEntity | null;
    attributeMappings?: EntityAttributeMapping[] | null;
    linkedFromEntity?: SourceEntity | null;
    linkedKeyAttribute?: EntityAttribute | null;
    linkedValueAttribute?: EntityAttribute | null;
    parameter?: string | null;
}

/** Een verzameling van uit de leveringszijde overgenomen operationele exemplaren met gemeenschappelijke kenmerken en attributen. */
export interface SourceEntity {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    model?: EntityModel | null;
    crs?: Crs | null;
    dataSource?: DataConnection | null;
    schema?: string | null;
}

/** Een verzameling van product-exemplaren met gemeenschappelijke kenmerken en attributen. */
export interface ProductEntity {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    model?: EntityModel | null;
    crs?: Crs | null;
}

export interface SearchResultOfProductFilterAndProductSearchResult {
    filter?: ProductFilter | null;
    results?: ProductSearchResult[] | null;
    totalcount?: number | null;
    paging?: Paging | null;
    sorting?: Sorting | null;
}

export interface ProductFilter {
    /** Product definition */
    definition?: number | null;
    /** Product metadata version description */
    versionDescription?: string | null;
    /** Product run execution start time */
    startExecutionFrom?: Date | null;
    /** Product run execution end time */
    startExecutionTo?: Date | null;
    /** Product run status */
    status?: number | null;
    /** Is it a dry run? */
    isDryRun?: boolean | null;
    /** The label of a product group: only the runs of the definitions in that group are returned */
    productGroupLabel?: string | null;
}

/** Product search result */
export interface ProductSearchResult {
    /** Product run id */
    id?: number;
    /** Product specification name */
    specification?: string | null;
    /** Product metadata version description */
    versionDescription?: string | null;
    /** Product run start execution time */
    startExecution?: Date | null;
    /** Product run end execution time
             */
    endExecution?: Date | null;
    /** Product run feedback */
    feedback?: string | null;
    /** Product run status */
    status?: string | null;
    /** Is dry run? */
    isDryRun?: boolean;
    /** Product process definition label */
    definition?: string | null;
    /** Are there warnings or errors in the product run? */
    hasNotifications?: boolean;
}

/** Uitvoering van een productproces, inclusief statusinformatie. */
export interface ProductRun {
    id?: number;
    runId?: string;
    status?: string | null;
    statusId?: number;
    failReason?: string | null;
    step?: string | null;
    specification?: ProductSpecification | null;
    metadata?: Metadata | null;
    startExecution?: Date | null;
    endExecution?: Date | null;
    runSteps?: RunStep[] | null;
    isFirstTime?: boolean;
    isDryRun?: boolean;
    canAbort?: boolean;
}

/** Gedetailleerde beschrijving van een of meerdere datasets, inclusief product-specifieke kenmerken zoals legende en distributievorm. */
export interface ProductSpecification {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    isMetadataContinuous?: boolean;
    skipMapping?: boolean;
    skipMetadataPublication?: boolean;
    entityLinks?: ProductEntityLink[] | null;
    definition?: ProductProcessDefinition | null;
}

/** Relatie die exemplaren van de ene met de andere productentiteit verbindt. */
export interface ProductEntityLink {
    id?: number;
    fromEntity?: ProductEntity | null;
    toEntity?: ProductEntity | null;
    attributeMappings?: EntityAttributeMapping[] | null;
    useRelatedSelection?: boolean;
}

export interface Metadata {
    uuid?: string | null;
    versionDate?: Date;
    versionDescription?: string | null;
    temporalLimitationFrom?: Date | null;
    temporalLimitationTo?: Date | null;
    runTimestamp?: Date | null;
}

export interface ProductStatusHistory {
    id?: number;
    status?: ProductStatusType | null;
    statusOn?: Date | null;
    statusBy?: string | null;
}

export interface ProductStatusType {
    id?: number;
    name?: string | null;
}

/** Product group, for the product group filter on the products overview */
export interface ProductGroup {
    /** Product group id */
    id?: number;
    /** Product group name, which the filter matches on */
    label?: string | null;
}

export interface CreateProduct {
    definitionId?: number;
    /** Is product creation first time? */
    isFirstTime?: boolean;
    /** Metadata */
    metadata?: Metadata | null;
}

/** Voor uitvoer bestemd type bestandformaat. */
export interface FormatType {
    code?: string | null;
    name?: string | null;
}

export interface Supplier {
    id?: number;
    name?: string | null;
}

export interface SearchResultOfSupplierFilterAndSupplierSearchResult {
    filter?: SupplierFilter | null;
    results?: SupplierSearchResult[] | null;
    totalcount?: number | null;
    paging?: Paging | null;
    sorting?: Sorting | null;
}

export interface SupplierFilter {
}

export interface SupplierSearchResult {
    id?: number;
    name?: string | null;
    kboNumber?: string | null;
    ovoNumber?: string | null;
}

export interface UserIdentity {
    name?: string | null;
    givenname?: string | null;
    surname?: string | null;
    email?: string | null;
    isAuthenticated?: boolean;
    orgCode?: string | null;
    roles?: string[] | null;
    myPolicies?: string[] | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}